import { use, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { getAccessToken } from './accesstoken';
import LocaleContext from './hooks/LocaleContext';

export const PrivateRoute = () => {
  const { userSettings, setLoggedIn } = use(LocaleContext);

  const token = getAccessToken();
  const { search, pathname } = useLocation();
  const redirectTo = encodeURIComponent(pathname + search);

  const shouldRedirect = !userSettings.loggedIn || token === '' || token === undefined;

  useEffect(() => {
    if (shouldRedirect) {
      setLoggedIn?.(false);
    }
  }, [shouldRedirect]);

  if (shouldRedirect) {
    return <Navigate to={'/signin?redirect=' + redirectTo} replace />;
  }

  return <Outlet />;
};
